import * as React from 'react';
import * as ReactDOM from 'react-dom';

import GridMonths from '../../components/grid/months';

import { GridMonthContainerProps } from '../../components/grid/container';


type GridState = { weekdaysShouldStick: boolean };

export class GridMonthContainerView extends React.Component<GridMonthContainerProps, GridState> {
    public topNavHeight;
    public calFiltersContainerHeight;
    public gridContainer;
    componentDidMount() {
        //this.topNavHeight = document.getElementById("navTop").getBoundingClientRect().height;
        let filters = document.querySelector(".ace-cal-filters-container");
        this.calFiltersContainerHeight = (filters) ? filters.getBoundingClientRect().height : 137;
        this.gridContainer = ReactDOM.findDOMNode(this);
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll = () => {
        window.requestAnimationFrame(() => {
            let stick = false;
            (this.gridContainer.getBoundingClientRect().top <= this.topNavHeight + this.calFiltersContainerHeight) ? stick = true : stick = false;
            this.setState({
                weekdaysShouldStick: stick
            });
        });
    };
    constructor(props: GridMonthContainerProps) {
        super(props);
        
        this.state = {
            weekdaysShouldStick: false
        };
    }
    render() {
        return (
            <div className={"ace-cal-grid-container " + (this.state.weekdaysShouldStick ? 'ace-cal-grid-container-stickweekdays' : '')}>
                <GridMonths />
            </div>
        );
    }
}

export default GridMonthContainerView;